import React from "react";
import { Link } from "react-router-dom";
import { LoginFormProp } from "../../../../../types/Others";
import { dynamicImage } from "../../../../../utils";
import { routes } from "../../../../../routers/routes";
import { Image } from "../../../../../coreComponents/Image";

const CommonLogo: React.FC<LoginFormProp> = ({ logoClass }) => {
  return (
    <Link className={`logo ${logoClass}`} to={routes.Dashboard.Default}>
      <Image className="img-fluid for-light" src={dynamicImage(`logo/logo.png`)} alt="logo" />
      <Image className="img-fluid for-dark" src={dynamicImage(`logo/logo_dark.png`)} alt="logo" />
    </Link>
  );
};
export default CommonLogo;
